import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TableOfContents.css';

const TableOfContents = ({ topicsData }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filtered subtopics based on search term
  const filteredTopics = topicsData.map((topic) => {
    return {
      ...topic,
      subtopics: topic.subtopics.filter((subtopic) =>
        subtopic.label.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    };
  });

  return (
    <div className="table-of-contents-container">
      <h2> <span className="toc-title">
        Topics &</span><span className="subtopics-span"> Subtopics</span>
      </h2>
      <div className="mini-void"></div>
      <div className="micro-void"></div>
      <p className="toc-description">
        Search or scroll down to find an area to learn more about.
      </p>
      <div className="micro-void"></div>
      <input
        type="text"
        className="search-bar"
        placeholder="Search Topics"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="micro-void"></div>
      <hr />

      {/* Iterate through categories and display subtopics */}
      {filteredTopics.map((topic, index) => (
        // Only render categories that have subtopics after filtering
        topic.subtopics.length > 0 && (
          <div key={index} className="toc-topic">
            <h2 className="topic-title">{topic.topic}</h2>
            <ul className="subtopics-list">
              {topic.subtopics.map((subtopic, subIndex) => (
                <li key={subIndex} className="subtopic-item">
                  <Link to={subtopic.link} className="subtopic-link">
                    {subtopic.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )
      ))}
      <div className="micro-void"></div>
      <hr />
    </div>
  );
};

export default TableOfContents;
